import { createSelector } from 'reselect'
import { currentParamsSelector } from './navigation'
import { RootState } from '../types/rootstate'

export const feedbackVotesSelector = (state: RootState) => state.feedbackVotes

export const currentFeedbackVoteFromParamsDetailsSelector = createSelector<
  RootState,
  RootState['feedbackVotes'],
  RootState['navigation']['navigationStacks']['key']['history'][0]['params'],
  RootState['feedbackVotes']['key']
>([feedbackVotesSelector, currentParamsSelector], (feedbackVotes, params) => {
  return feedbackVotes[String(params.articleId)]
})
